<template>
	<div style="flex: 1;padding: 20px;display: flex;flex-direction: column;color:#fff;font-size: 14px;">
		<div style="flex:1;background-color: rgb(75, 83, 87);display: flex;flex-direction: column;">
			<div style="padding: 15px;border-bottom: 1px solid #3f4649;display: flex;align-items: center;justify-content: space-between;">
				数据列表
				<div style="display: flex;align-items: center;">
					<span style="margin-right: 10px;">共{{total}}条数据</span>
					<el-button icon="el-icon-refresh" type="primary" size="small" style="border-radius: 0;" @click="getData">刷新数据</el-button>
				</div>
			</div>
			<div style="padding: 18px;display: flex;align-items: center;" class="search">
				<el-input clearable placeholder="数据Key" v-model="form.serach_key" size="small"
					style="width: 250px;margin-right: 20px;" @clear="getData">
					<el-button slot="append" type="primary" icon="el-icon-search" @click="search"></el-button>
				</el-input>
				<div style="display: flex; align-items: center;margin-left: auto;">
					<el-button type="danger" size="small" style="border-radius: 0;"
						:disabled="multipleSelection.length===0" @click="deleteAll">删除</el-button>
				</div>
			</div>
			<div style="padding: 0px 20px 0px 20px;">
				<el-table :data="list" stripe
					style="width: 100%;flex: 1;padding:0px 0px;background-color: rgb(75, 83, 87);color: #fff;" size="small"
					@selection-change="handleSelectionChange"
					:header-cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}"
					:cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}" :row-style="{border_color:'rgb(75, 83, 87)'}"
					height="550" v-loading="loading">
					<el-table-column type="selection" width="55">
					</el-table-column>
					<el-table-column label="数据Key" align="center" min-width="100">
						<template slot-scope="scope">
							{{scope.row.key}}
						</template>
					</el-table-column>
					<el-table-column label="数据预览" align="center" width="170">
						<template slot-scope="scope">
							{{scope.row.val_str}}
						</template>
					</el-table-column>
					<el-table-column label="修改时间"  align="center" width="170">
						<template slot-scope="scope">
							{{scope.row.change_time}}
						</template>
					</el-table-column>
					<el-table-column label="操作" width="300" align="center">
						<template slot-scope="scope">
							<el-button type="warning" size="mini" @click="toEdit(scope.row.key)">修改</el-button>
							<el-button type="danger" size="mini" @click="toDelete(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="footer" style="margin-top: 15px;">
				<el-pagination layout="total, prev, pager, next,sizes" @current-change="toPage" :total="total"
					:page-sizes="[10,25,50,100]" :current-page="form.page" :page-size="limit"  @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		computed: {
			...mapState({
				user: state => state.user,
				reload:state=>state.reload
			})
		},
		watch:{
			reload(n,v){
				this.getData()
			}
		},
		data() {
			return {
				cards: '',
				loading: false,
				days: 0,
				limit: 15,
				total: 0,
				form: {
					page:1,
					serach_key:"",
				},
				software_list: [],
				now_timestamp: 0,
				list: [],
				multipleSelection: []
			}
		},
		filters: {
			formatTime(value) {
				if (value == 0) return ''
				let date = new Date(value * 1000)
				var year = date.getFullYear();
				var month = ("0" + (date.getMonth() + 1)).slice(-2);
				var sdate = ("0" + date.getDate()).slice(-2);
				var hour = ("0" + date.getHours()).slice(-2);
				var minute = ("0" + date.getMinutes()).slice(-2);
				var second = ("0" + date.getSeconds()).slice(-2);
				// 拼接
				var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
				// 返回
				return result;
			}
		},
		created() {
			this.getData()
			this.now_timestamp = window.localStorage.getItem('timestamp_'+this.$store.state.user.center_id)
		},
		methods: {

			confromCard() {
				this.dialogOptions = true
			},
			toEdit(key) {
				this.$emit('toEdit', key)

			},
			deleteAll(){
				let ids = this.multipleSelection.map(item=>item.id)
				this.$confirm('是否删除选中数据？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$H.post('verify_center/v1_0_1.Data/Option',{
						ids,
						option:'delete'
					}).then(res => {
						if(!res.data) return;
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.search()
					});
				
				}).catch(() => {
				
				});
			},
			toDelete(item) {
				this.$confirm('是否删除该数据？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$H.post('verify_center/v1_0_1.Data/Option',{
						ids:[item.id],
						option:'delete'
					}).then(res => {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.search()
					});

				}).catch(() => {

				});
			},
			
			search() {
				this.form.page = 1
				this.getData()
			},
			getData() {
				this.loading = true
				this.$H.post('/verify_center/v1_0_1.Data/List', this.form).then(res => {
					this.loading = false
					if (res.data) {
						if (this.form.page === 1) {
							this.total = res.data.list.total
						}

						this.list = res.data.list.data

					}
				}).catch(err => {
					this.loading = false
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			toPage(val) {
				this.form.page = val
				this.getData()
			},
			handleSizeChange(val){
				this.form.limit = val
				this.form.page = 1
				this.getData()
			}
		}
	}
</script>

<style>
	.search input {
		background-color: rgb(75, 83, 87);
		color: #fff;
		border-radius: 0px;

	}

	.el-dialog__header {
		background-color: #409EFF;
		color: #fff;
	}

	.el-dialog__header .el-dialog__title {
		color: #fff;
	}

	.el-dialog__close el-icon el-icon-close {
		color: #fff;
	}

	.footer {
		margin-top: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px 0;
	}

	.footer .el-pagination__total {
		color: #fff !important;
	}

	.footer input {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
		border-radius: 0;
	}

	.footer>>>.btn-prev {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
	}

	.el-table td.el-table__cell,
	.el-table th.el-table__cell.is-leaf {
		border-bottom: 1px solid #909399 !important;
	}
</style>